export const LAST_NAME_INPUT_MAX_LEGTH = 24;
